export default __webpack_public_path__ + "static/media/dropdown-light-grey.32951a5e.svg";